var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.316 14.329a.803.803 0 0 0 1.075-.076L11 9.495l4.61 4.758a.803.803 0 0 0 1.158 0A.829.829 0 0 0 17 13.68a.818.818 0 0 0-.24-.58l-5.182-5.352a.802.802 0 0 0-1.156-.002l-5.19 5.358c-.31.32-.31.83 0 1.15l.084.076z"
  })));
};

export default SvgArrowUp;